"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

var _MuiAppBar = _interopRequireDefault(require("../MuiAppBar/MuiAppBar"));

var _MuiMobileStepper = _interopRequireDefault(require("../MuiMobileStepper/MuiMobileStepper"));

var _MuiHeroHeader = _interopRequireDefault(require("../MuiHeroHeader/MuiHeroHeader"));

var _MuiCircularProgress = _interopRequireDefault(require("../MuiCircularProgress/MuiCircularProgress"));

var _MuiGridList = _interopRequireDefault(require("../MuiGridList/MuiGridList"));

var _MuiButtonRedirect = _interopRequireDefault(require("../MuiButtonRedirect/MuiButtonRedirect"));

var _MuiCard = _interopRequireDefault(require("../MuiCard/MuiCard"));

var _MuiTypography = _interopRequireDefault(require("../MuiTypography/MuiTypography"));

var _MuiMenu = _interopRequireDefault(require("../MuiMenu/MuiMenu"));

var _MuiIcon = _interopRequireDefault(require("../MuiIcon/MuiIcon"));

var _MuiAccordion = _interopRequireDefault(require("../MuiAccordion/MuiAccordion"));

var _MuiList = _interopRequireDefault(require("../MuiList/MuiList"));

var _MuiTable = _interopRequireDefault(require("../MuiTable/MuiTable"));

var _MuiPaginationTable = _interopRequireDefault(require("../MuiPaginationTable/MuiPaginationTable"));

var _MuiContactButton = _interopRequireDefault(require("../MuiContactButton/MuiContactButton"));

var _MuiImage = _interopRequireDefault(require("../MuiImage/MuiImage"));

var _MuiButtonHref = _interopRequireDefault(require("../MuiButtonHref/MuiButtonHref"));

var _MuiNotificationBanner = _interopRequireDefault(require("../MuiNotificationBanner/MuiNotificationBanner"));

var _BlokForm = _interopRequireDefault(require("../BlokForm/BlokForm"));

var _MuiAudioPlayer = _interopRequireDefault(require("../MuiAudioPlayer/MuiAudioPlayer"));

var _GoogleConversions = _interopRequireDefault(require("../GoogleConversions/GoogleConversions"));

var _MuiIconButtonDialog = _interopRequireDefault(require("../MuiIconButtonDialog/MuiIconButtonDialog"));

var _MuiButtonDialog = _interopRequireDefault(require("../MuiButtonDialog/MuiButtonDialog"));

var _MuiGeoLocationMobileStepper = _interopRequireDefault(require("../MuiGeoLocationMobileStepper/MuiGeoLocationMobileStepper"));

var _MuiResponsiveDrawer = _interopRequireDefault(require("../MuiResponsiveDrawer/MuiResponsiveDrawer"));

var MuiGrid = function MuiGrid(props) {
  var components = {
    MuiHeroHeader: _MuiHeroHeader.default,
    MuiAppBar: _MuiAppBar.default,
    MuiMobileStepper: _MuiMobileStepper.default,
    MuiCircularProgress: _MuiCircularProgress.default,
    MuiGridList: _MuiGridList.default,
    MuiButtonRedirect: _MuiButtonRedirect.default,
    MuiCard: _MuiCard.default,
    MuiTypography: _MuiTypography.default,
    MuiMenu: _MuiMenu.default,
    MuiIcon: _MuiIcon.default,
    MuiAccordion: _MuiAccordion.default,
    MuiList: _MuiList.default,
    MuiTable: _MuiTable.default,
    MuiPaginationTable: _MuiPaginationTable.default,
    MuiContactButton: _MuiContactButton.default,
    MuiImage: _MuiImage.default,
    MuiButtonHref: _MuiButtonHref.default,
    MuiNotificationBanner: _MuiNotificationBanner.default,
    BlokForm: _BlokForm.default,
    MuiAudioPlayer: _MuiAudioPlayer.default,
    GoogleConversions: _GoogleConversions.default,
    MuiGeoLocationMobileStepper: _MuiGeoLocationMobileStepper.default,
    MuiIconButtonDialog: _MuiIconButtonDialog.default,
    MuiButtonDialog: _MuiButtonDialog.default,
    MuiResponsiveDrawer: _MuiResponsiveDrawer.default
  };
  return /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({}, props, {
    components: components
  }));
};

var _default = MuiGrid;
exports.default = _default;